import { Check } from 'lucide-react';

const Header = ({
  icon: Icon,
  iconBg,
  iconColor,
  title,
  description,
  completed = false,
  action = null
}) => {
  return (
    <div className="flex items-center gap-3">
      <div className="relative shrink-0">
        <div className={`flex h-10 w-10 items-center justify-center rounded-xl ${iconBg}`}>
          <Icon size={20} className={iconColor} />
        </div>

        {completed && (
          <span
            title="Completed"
            className="absolute -bottom-1 -right-1 flex h-[18px] w-[18px] items-center justify-center rounded-full bg-success-500 text-white ring-2 ring-white"
          >
            <Check size={10} strokeWidth={3.5} />
          </span>
        )}
      </div>

      <div className="min-w-0 flex-1">
        <p className="text-lg font-bold leading-tight text-base-content">{title}</p>

        <p className="mt-1 text-xs text-gray-500">{description}</p>
      </div>

      {action && <div className="shrink-0">{action}</div>}
    </div>
  )
}

export default Header;
